import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState, useMemo } from "react";

const EditAttachmentModalContent = ({
  initialFileName,
  initialDescription,
  onSave,
}) => {
  const lastDotIndex = initialFileName.lastIndexOf(".");
  const nameNoExtension =
    lastDotIndex === -1
      ? initialFileName
      : initialFileName.slice(0, lastDotIndex);
  const extension =
    lastDotIndex === -1 ? "" : initialFileName.slice(lastDotIndex + 1);

  const [localName, setLocalName] = useState(nameNoExtension);
  const [localDescription, setLocalDescription] = useState(initialDescription);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    const filename = `${localName}.${extension}`;
    await onSave(filename, localDescription);
  };

  useEffect(() => {
    setLocalName(nameNoExtension);
    setLocalDescription(initialDescription);
  }, [nameNoExtension, initialDescription]);

  const isChanged = useMemo(() => {
    return (
      localName.trim() !== nameNoExtension.trim() ||
      localDescription.trim() !== initialDescription.trim()
    );
  }, [localName, localDescription, nameNoExtension, initialDescription]);

  return (
    <Box>
      <Text fontSize="lg" mb={2} fontWeight="bold">
        Edit Attachment
      </Text>

      <FormControl mb={4}>
        <FormLabel>File Name</FormLabel>
        <Flex align="center" gap={2}>
          <Input
            value={localName}
            onChange={(e) => setLocalName(e.target.value)}
          />
          <Text>.{extension}</Text>
        </Flex>
      </FormControl>

      <FormControl>
        <FormLabel>Description</FormLabel>
        <Input
          value={localDescription}
          onChange={(e) => setLocalDescription(e.target.value)}
        />
      </FormControl>

      <Flex justifyContent="flex-end" mt={4}>
        <Button
          variant="primary"
          onClick={handleSave}
          isLoading={isSaving}
          isDisabled={isSaving || !isChanged}
          loadingText="Saving..."
          spinner={<Spinner size="sm" />}
          _disabled={{
            cursor: "default",
            opacity: 0.4,
          }}
          _hover={{ bg: "bgColor", color: "white" }}
        >
          Save
        </Button>
      </Flex>
    </Box>
  );
};

export default EditAttachmentModalContent;
